import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatPagination from '@components/common/satUI/SatPagination';

import { showModal } from '@store/actions/commonAction';
import Layout from '@components/common/Layout';

import {
  getCommonCodeDtlList,
  getProdOrderList,
  prdtSearchByChannel,
  getRiderSortList,
  getRiderSortListClear,
  editRiderSortOrder,
} from '@store/actions/managementProductAction';
import { changeArrayOrder } from '@common/utils';

const columns = [
  {title:'채널', key:'orgChnlNm', dataIndex:'orgChnlNm'},
  {title:'상품군', key:'saleProdGrpNm', dataIndex:'saleProdGrpNm'},
  {title:'상품코드', key:'prodCd', dataIndex:'prodCd'},
  {title:'상품명', key:'prodNm', dataIndex:'prodNm'},
]
const riderSortListCol = [
  {title:'특약', key:'sortIndex', dataIndex:'sortIndex', headerColSpan : 3 },
  {title:'특약', key:'prodNm', dataIndex:'prodNm', isNoHeader:true},
  {title:'특약', key:'prodNm2', dataIndex:'prodNm2', isNoHeader:true, render : (value, row) => {
    if(row.defaultRider === 'Y'){
      return (
        <span className='status-label duty'>추천특약</span>
      )
    }
    else if(row.fixedRider === 'Y'){
      return (
        <span className='status-label default'>의무부가</span>
      )
    }
  }},
]

const ManagementSystemProductOrder = () => {
  const { 
    commonCodeDtl,
    prdtCodeList,
    prodOrderList,
    prodOrderRows,
    prodOrderTargetRow,
    riderSortList,
    riderSortListRows,
  } = useSelector(state => state.managementProductReducer);

  const dispatch = useDispatch();
  const [selectRow, setSelectRow] = useState({
    rowIndex : '',
  });
  const [dtlSelectRow, setDtlSelectRow] = useState({
    rowIndex : '',
  });

  const [grid, setGrid] = useState([]);
  const [dtlGrid, setDtlGrid] = useState([]);

  const [searchVal, setSearchVal] = useState({
    channel : '',
    prdt : '',
    val : '',
  })

  const [isModify, setIsModify] = useState(false);

  useEffect(()=>{
    dispatch(getCommonCodeDtlList({
      cdTyId : 'ORG_CHNL_CD'
    }))
  }, [])

  useEffect(()=>{
    if(prodOrderList.length === 0 && prodOrderTargetRow !== 0){
      dispatch(showModal({
        visible : true,
        type    : 'info',
        msg     : '검색결과가 없습니다.',
      }))

      setGrid([]);
    }
    else{
      let tmp = [...prodOrderList];
      tmp.forEach((item)=>{
        item.orgChnlNm = commonCodeDtl.filter(cd => cd.cdVal === item.orgChnlCd)[0].cmnCdNm
      })
      
      setGrid(tmp);
    }
  }, [prodOrderList])
  
  useEffect(()=>{
    let tmp = [...riderSortList];
    
    tmp.forEach((item, index)=>{
      item['sortIndex'] = index + 1;
    })
    setDtlGrid(tmp);
  }, [riderSortList])

  const selectClear = () => {
    setSelectRow({rowIndex:''});
    setDtlSelectRow({rowIndex:''})
  }

  const onOptionChange = (e) => {
    const {name, value} = e.target;

    setSearchVal({
      ...searchVal,
      [name] : value
    })

    if(name === 'channel'){
      dispatch(prdtSearchByChannel({
        orgChnlCd : value
      }))
    }
  }

  const onPrdtSearchInputChnageHandler = (e) => {
    setSearchVal({
      ...searchVal,
      ['val'] : e.target.value
    })
  }

  const onSearchInputKewDownHandler = (e) => {
    if(e.keyCode === 13){
      onSearch()
    }
  }

  const onSearch = () => {
    if(searchVal.channel.trim() === ''){
      dispatch(showModal({
        visible : true,
        type    : 'info',
        msg     : '채널을 선택해주세요.',
        moveFocus : true,
      }))
      return ;
    }

    setIsModify(false);
    selectClear();
    dispatch(getRiderSortListClear());

    dispatch(getProdOrderList(searchVal))
  }

  const onModify = () => {
    if(dtlSelectRow.rowIndex === ''){
      dispatch(showModal({
        visible : true,
        type    : 'info',
        msg     : '수정할 상품을 선택하세요.',
      }))

      return;
    }

    setIsModify(true);
  }
  const onCancel = () => {
    setIsModify(false);
  }
  const onSave = () => {
    setIsModify(false);

    dispatch(editRiderSortOrder(dtlGrid));
  }

  const onUpClick = () => {
    const tmp = [...changeArrayOrder(dtlGrid, dtlSelectRow.rowIndex, -1)];

    if(tmp.length > 0){
      tmp?.forEach((item, index)=>{
        item['sortIndex'] = index+1;
      })
      setDtlGrid(tmp);
      setDtlSelectRow({rowIndex : dtlSelectRow.rowIndex-1});
    }
  }
  const onDownClick = () => {
    const tmp = [...changeArrayOrder(dtlGrid, dtlSelectRow.rowIndex, +1)];

    if(tmp.length > 0){
      tmp?.forEach((item, index)=>{
        item['sortIndex'] = index+1;
      })
      setDtlGrid(tmp);
      setDtlSelectRow({rowIndex : dtlSelectRow.rowIndex+1});
    }
  }

  return (
    <Layout>
      <div className='con-wrap'>
        <div className='app-wrap'>
          <div className='app-box'>
            <div className='con-bottom'>
              <div className='tit-area'>
								<h2 className='tit-con'>상품별특약순서관리</h2>
							</div>
              <div className='search-box'>
                <div className='data-group-left'>
                  <div className='data-area'>
                    <span className='data-tit'>채널</span>
                    <div className='sel-group'>
											<select name='channel' value={searchVal.channel} onChange={onOptionChange}>
												<option value=''>전체</option>
                        {commonCodeDtl.map((item, index) => (
                          <option
                            key={`commonCodeDtl_${index}`}
                            value={item.cdVal}
                          >{item.cmnCdNm}
                          </option>
                        ))}
											</select>
										</div>
                  </div>
                </div>
                <div className='data-group-left'>
                  <div className='data-area'>
                    <span className='data-tit'>상품</span>
                    <div className='sel-group'>
                      <select name='prdt' value={searchVal.prdt} onChange={onOptionChange}>
                        <option value=''>전체</option>
                        {prdtCodeList.map((item, index) => (
                          <option
                            key={`prdtCodeList_${index}`}
                            value={item.saleProdGrpCd}
                          >{item.saleProdGrpNm}

                          </option>
                        ))}
                      </select>
                    </div>
                    <div className='input-wrap input-search'>
                      <input
                        type={'text'}
                        id={'text1'}
                        className={'input'}
                        placeholder={'검색어를 입력하세요.'}
                        value={searchVal.val}
                        onChange={onPrdtSearchInputChnageHandler}
                        onKeyDown={onSearchInputKewDownHandler}
                      />
                    </div>
                  </div>
                </div>
                <button className='btn-search' onClick={onSearch}>검색</button>
              </div>
              <div className='col-tbl-wrap'>
                <div className='table-wrap-reg'>
                  <div className='tit-mini'>전체 {prodOrderRows}건</div>
                  <div className='table-wrap'>
                    {/* 그리드 */}
                    <SatDataGrid
                      columns={columns}
                      customStyleClass={'depth1'}
                      dataSource={grid}
                      noDataRender={'검색결과가 없습니다.'}
                      onRowSelection={(data)=>{
                        setSelectRow({
                          rowIndex : data.rowIndex,
                        })
                        setDtlSelectRow({rowIndex: ''})

                        dispatch(getRiderSortList(data))
                      }}
                      setRowStyle={(data)=>{
                        if(selectRow.rowIndex === data.rowIndex){
                          return 'active'
                        }
                      }}
                    />
                  </div>
                  {prodOrderRows > 10 && 
                    <SatPagination
                      totalCount={prodOrderRows}
                      onChange={(index) => {
                        dispatch(getProdOrderList({
                          ...searchVal,
                          targetRow : index*10 + 1
                        }))
                        selectClear();

                        dispatch(getRiderSortListClear())
                      }}
                    />
                  }
                </div>
                <div className='table-wrap-reg'>
                  <div className='no-round-box'>
                    <div className='tit-area'>
                      <h3>상품정보</h3>
                    </div>
                    <div className='table-wrap'>
                      <SatDataGrid
                        columns={riderSortListCol}
                        customStyleClass={'depth1'}
                        dataSource={dtlGrid}
                        noDataRender={'검색결과가 없습니다.'}
                        onRowSelection={(data)=>{
                          setDtlSelectRow({
                            rowIndex : data.rowIndex,
                          })
                        }}
                        setRowStyle={(data)=>{
                          if(dtlSelectRow.rowIndex === data.rowIndex){
                            return 'active'
                          }
                        }}
                      />
                    </div>
                    {isModify && 
                      <div className="btn-area-updown">
                        <button className="updown-btn ico btn-com-chevron-up" onClick={onUpClick}>up</button>
                        <button className="updown-btn ico btn-com-chevron-down" onClick={onDownClick}>down</button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='btn-area-jb'>
              <ul className="file-list">
              {isModify === true ? (
                <>
                    <li>
                      <button className="btn-m cancel" onClick={onCancel}>취소</button>
                    </li>
                    <li>
                      <button className="btn-m save" onClick={onSave}>저장</button>
                    </li>
                </>
              ) : (
                <>
                  <li>
                    <button className='btn-m modify' onClick={onModify}>수정</button>
                  </li>
                </>
              )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ManagementSystemProductOrder;
